import React from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import DelayedInvoicesTable from "./DelayedInvoicesTable/DelayedInvoicesTable";

function DelayedInvoices() {
  return (
    <div className="apDiv delayedInvoices">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header isSearch="false" title="الفواتير المؤجلة" />
        </div>
        
        <DelayedInvoicesTable />
      </div>
    </div>
  );
}

export default DelayedInvoices;
